import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { syncClarityIdentify } from '@/utils/clarity';

/**
 * Keeps Clarity Identify in sync with auth and SPA navigations (per Microsoft guidance).
 */
export function ClaritySessionSync() {
  const location = useLocation();

  useEffect(() => {
    const run = () => syncClarityIdentify();
    run();
    window.addEventListener('clubsbooking-auth-updated', run);
    return () => window.removeEventListener('clubsbooking-auth-updated', run);
  }, [location.pathname, location.search]);

  return null;
}
